<template>
  <Form v-bind="$attrs" @invalidSubmit="invalid">
      <slot></slot>
  </Form>
</template>

<script>
import { Form } from "vee-validate";

export default {
  components: {
    Form,
  },
  methods: {
    invalid() {
      document.querySelector("input.error")?.scrollIntoView();
    },
  },
};
</script>
